// Cart links handler.

const addProductToCart = async (items) => {
	const formData = {
		items: items,
	};
	const response = await fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	});

	if (!response.ok) {
		throw new Error('Failed to add product to cart');
	}
	return await response.json();
};

const setLoading = () => {
	// cart__loading-text
	// cart__empty-text
	const cartEmptyText = document.querySelector('.cart__empty-text');
	const cartLoadingText = document.querySelector('.cart__loading-text');
	cartEmptyText.style.display = 'none';
	cartLoadingText.style.display = 'block';
}

const checkCartItemsAndFooter = () => {
	// If we have an update but the rerendering failed. We reload the cart
	const cartItems = document.getElementById('main-cart-items');
	const cartFooter = document.getElementById('main-cart-footer');

	// fetch the cart again
	if (cartItems.classList.contains('is-empty') || cartFooter.classList.contains('is-empty')) {
		// check if the cart is empty
		console.log('Cart is empty fetche cart');
		fetch(`${Shopify.routes.root}cart.js`)
			.then((response) => response.json())
			.then((cart) => {
				if(cart.item_count > 0) {
					window.location.reload();
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const params = new URLSearchParams(window.location.search);
	// If found consent params event to doc for consent
	const consentParam = params.get('consentData');
	const idsParam = params.get('ids');
	// console.log('params:', params);
	if(consentParam){
		document.dispatchEvent(new CustomEvent('consent:params', { bubbles: true, detail: { params } }));
	} else {
		const body = document.querySelector('body');
		body.classList.remove("hide-banner");
	}
	if (idsParam) {
		console.log('Add param found:', idsParam);
		const ids = params.get('ids').split(',');
		console.log(ids);
		const items = ids.map((variantElement) => {
			const [id, quantity] = variantElement.split(':');
			return { id, quantity };
		});
		setLoading();
		addProductToCart(items)
			.then((response) => {
				console.log('Product added to cart', response);
        // know remove the url with params from history
        window.history.replaceState({}, document.title, window.location.pathname);
        // cart:refresh event is dispatched when the cart is updated
        setTimeout(() => {
          document.dispatchEvent( new CustomEvent('cart:refresh', { bubbles: true }));
        }, 10);
				setTimeout(() => {
					// fallback if the cart is not rerendered
					checkCartItemsAndFooter();
				}, 3500);
			})
			.catch((error) => {
				console.error('Failed to add product to cart', error);
			});
	}

});
